import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getSharingTypeIcon } from '../../../../../../shared/functions/Functions';
import { CampaignSharingType } from '../../../../../../enum/CampaignSharingTypeEnum';
import { Company } from '../../../../../../model/user/Company';
import CardLayout from '../../../../../../shared/components/card/CardLayout';

interface ICampaignManagementOverviewCardProps {
    type?: CampaignSharingType;
    company?: Company;
}
export function CampaignManagementOverviewCard({ type, company }: ICampaignManagementOverviewCardProps) {
    const { t } = useTranslation();
    function getDescription() {
        switch (type) {
            case CampaignSharingType.CLIENT:
                return t('brand.campaign.briefing.client_desc');
            case CampaignSharingType.SUPPLIER:
                return t('brand.campaign.briefing.supplier_desc');
            case CampaignSharingType.OWN_MANAGEMENT:
                return t('brand.campaign.briefing.own_management_desc');
        }
    }

    return (
        <CardLayout>
            <h5 className="mb-3">{t('brand.campaign.briefing.campaign_management')}</h5>
            <Row>
                <Col md={4} className="d-flex align-items-center justify-content-center">
                    {getSharingTypeIcon(t, type ?? CampaignSharingType.OWN_MANAGEMENT, true, 'h1')}
                </Col>
                <Col md={8} className="d-flex align-items-center">
                    <div className="py-2">
                        <h5 className="font-weight-bold">{company?.displayName}</h5>
                        <p className="text-muted mb-0">{getDescription()}</p>
                    </div>
                </Col>
            </Row>
        </CardLayout>
    );
}
